import { Component, OnInit, AfterViewInit, OnDestroy, Inject, ViewEncapsulation, HostListener } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ErrorStateMatcher } from '@angular/material/core';
import { UntypedFormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { ConfirmDialogComponent } from './../../../../common/components/confirm-dialog/confirm-dialog.component';
import { SliderModelService } from './../../../../services/infrastructure/sliderModel.service';
import { LoaderService } from './../../../../services/infrastructure/loader.service';
import { CppProductlabel } from './../../../../services/cpp/cpp-product-label.service';
import { LolLoggerService } from './../../../../common/shared/lol-logger.service';
import { LocalStorageService } from './../../../../services/infrastructure/local-storage.service';
import { BroadcastService } from './../../../../services/infrastructure/broadcaster.service';
import { ConfigService } from './../../../../services/infrastructure/config.service';
import { MasterConstants } from '../../../../common/constants/master-constants';
import { CommonService } from './../../../../services/common/common.service';
import * as $ from 'jquery';

@Component({
  selector: 'app-cpp-product-label-form',
  templateUrl: './cpp-product-label-form.component.html',
  styleUrls: ['./cpp-product-label-form.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CppProductLabelFormComponent implements OnInit, AfterViewInit, OnDestroy {
  private subscription = new Array<Subscription>();
  shipToData: any;
  showTabs = false;
  shipToDataLoading: boolean = true;
  userMenuAccessList: any;
  selectedItemId: number | null = null;
  productLabelItemList: any[] = [];
  ddldeliveryList = [
    { id: 'Y', value: 'Yes' },
    { id: 'N', value: 'No' }
  ];
  dataCount = 0;
  hasChangeAdded = false;
  isPlaceOrderDisable = true;
  selectedItems: any[] = [];
  dataSource = [...this.selectedItems];
  displayedColumns: string[] = ['select', 'product', 'labelQty'];
  readOnlyAccess = false;
  formdata: any;
  isNotValid = false;
  warningMessage: string = null;
  emailPattern: any = MasterConstants.EMAIL_PATTERN;
  matcher = new InputErrorStateMatcher(this.isNotValid);
  tabNode: '';
  // For adding a new item
  isAddingNewItem = false;
  newItemName = '';
  selectedCount = 0;
  constructor(
    private router: Router,
    private loaderService: LoaderService,
    private cppProductlabel: CppProductlabel,
    private localStorageService: LocalStorageService,
    private toastrService: ToastrService,
    private matDialog: MatDialog,
    private commonService: CommonService,
    private datePipe: DatePipe,
    public broadcastService: BroadcastService,
    private configService: ConfigService,
    public sliderModelService: SliderModelService) {
  }

  ngOnInit(): void {
    this.setDefaultformData();
    this.getUnauthorizedProductWarningMessage();
    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        this.userMenuAccessList = data.resultData.find(x => x.userIdCompanyCode == MasterConstants.US_COMPANYCODE).userMenuAccessList;
        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.CROP_PROTECTION_PRODUCT_ORDER))
        {
          this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.CROP_PROTECTION_PRODUCT_ORDER, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList);
          if (!this.readOnlyAccess) {
            this.getShipToData();
            this.getProductList();
          } else {
            this.shipToDataLoading = false;
          }
        }
        else {
          this.router.navigate(['/cc/landing-data']);
        }
      }
    }

  }

  ngAfterViewInit() {
  //  this.setPageHeight();
  }

  // @HostListener('window:resize', ['$event']) onresize(event) {
  //   this.setPageHeight();
  // }

  // setPageHeight() {
  //   setTimeout(function () {
  //     const templateMinHeight = window.innerHeight - $('h3').outerHeight() - $('.OrderReleaseTop').outerHeight() - $('.productsection').outerHeight() - 190;
  //     const templateMaxHeight = window.innerHeight - $('h3').outerHeight() - $('.OrderReleaseTop').outerHeight() - $('.productsection').outerHeight() - 189;

  //     $('.tableOuterContainer').css('min-height', templateMinHeight + 'px');
  //     $('.tableOuterContainer').css('max-height', templateMaxHeight + 'px');
  //   }, 100);
  // }

  public ngOnDestroy(): void {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }

  setDefaultformData() {
    this.formdata = {
      accountNumber: null,
      accountName:null,
      address: null,
      city: null,
      state: null,
      zipCode: null,
      overNightDelivery: "N",
      orderedBy: null,
      accountManager: null,
      attn: null,
      email: null,
      customerPO: null,
      orderedDate:this.datePipe.transform(new Date(), 'MM/dd/yyyy'),
      cppproductLabelItems:[]
    };
  }
  getUnauthorizedProductWarningMessage() {
    this.subscription.push(this.cppProductlabel
      .getUnauthorizedProductWarningMessage()
      .subscribe(
        (result: any) => {
          if (result && result.status) {
            this.warningMessage = result.message;
          }
        },
        (error) => LolLoggerService.error(error)
      ));
  }

  getShipToData() {
    this.subscription.push(this.cppProductlabel
      .getProductLabelAccountList()
      .subscribe(
        (result:any) => {
          this.shipToData = result;
          this.shipToDataLoading = false;
        },
        (error) => LolLoggerService.error(error)
      ));
  }
  getProductList() {
    this.subscription.push(this.cppProductlabel
      .getProductLabelItemsList()
      .subscribe(
        (result: any) => {
          this.productLabelItemList = result;
        },
        (error) => LolLoggerService.error(error)
      ));
  }

  enableAllCheckBoxes(isChecked) {
    if (isChecked) {
      this.showTabs = true;
      this.selectedItems.forEach(x => {
        x.selected = true;
      });
      this.selectedCount = this.selectedItems.length;
    }
    else {
      this.showTabs = false;
      this.selectedItems.forEach(x => {
        x.selected = false;
      });
      this.selectedCount = 0;
    }
  }

  enableCheckBoxSingle(isChecked) {
    if (isChecked) {
      this.showTabs = true;
      this.selectedCount = this.selectedCount + 1;
    }
    else {
      this.selectedCount = this.selectedCount - 1;
      const checked = this.selectedItems.filter(x => x.selected == true);
        if (checked && checked.length == 0) {
          this.showTabs = false;
        }
    }
  }

  onAccountInputChange(event) {
    if (event && event.accountNumber) {
      this.formdata.accountName = event.accountName;
    }
    else {
      this.formdata.accountName = null;
    }
  }

  accountSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return (
      item.accountName.toLocaleLowerCase().indexOf(term) > -1 ||
      item.accountNumber.toString().indexOf(term) > -1 ||
      item.address1.toLocaleLowerCase().indexOf(term) > -1 ||
      item.city.toLocaleLowerCase().indexOf(term) > -1 ||
      item.state.toLocaleLowerCase().indexOf(term) > -1 ||
      item.zipCode.toLocaleLowerCase().indexOf(term) > -1
    );
  }
  public filterSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.productName.toLocaleLowerCase().indexOf(term) > -1;
  }

  keyPressNumbers(event) {
    const numbers = /^[-+]?[0-9]+$/;
    if (!numbers.test(event.key)) {
      return false;
    }
  }

  onItemSelected() {
    if (this.selectedItemId) {
      const selectedItem = this.productLabelItemList.find(item => item.itemId === this.selectedItemId);

      if (selectedItem) {
        this.selectedItems.push({ itemId: selectedItem.itemId, productName: selectedItem.productName, quantity: 0, selected: false });
        this.dataSource = [...this.selectedItems];

        this.productLabelItemList = this.productLabelItemList.filter(item => item.itemId !== selectedItem.itemId);
        this.selectedItemId = null;
      }
    }
  }

  setcount() {
    this.dataCount = this.selectedItems.filter(x => x.quantity > 0).length;
    this.isPlaceOrderDisable = this.dataCount > 0 ? false : true;
    this.hasChangeAdded = true;
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { plDataChange: true, labelNo: 'No, go back to Order' });
  }

  navigateTolandingProductLabel() {
    if (this.hasChangeAdded) {
      const title = 'Leave without saving?';
      const message = '';
      const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '480px',
        data: { title: title, message: message, labelYes: 'Yes', labelNo: 'No, go back to Order', dialogType: 'confirm' }
      });
      dialogRef.afterClosed().subscribe(result => {
        // If user selected Yes
        if (result == true) {
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cancelBtnClick: true });
          const closebutton = document.getElementsByClassName('close-btn')[0] as HTMLElement;
          closebutton.style.display = '';
          this.sliderModelService.close();
          this.router.navigate(['/cpp/product-label-landing']);
        }
      });
    }
    else {
      const closebutton = document.getElementsByClassName('close-btn')[0] as HTMLElement;
      closebutton.style.display = '';
      this.sliderModelService.close();
      this.router.navigate(['/cpp/product-label-landing']);
    }
  }

  deleteSelectedItems(value) {
    if (value) {
      const itemsToDelete = this.selectedItems.filter(item => item.selected);
      this.selectedItems = this.selectedItems.filter(item => !item.selected);
      this.dataSource = [...this.selectedItems];
      itemsToDelete.forEach(item => {
        if (item.itemId > 0) {
          const deletedItem = { itemId: item.itemId, productName: item.productName };
          this.productLabelItemList = [...this.productLabelItemList, deletedItem];
        }
      });
      this.selectedCount = 0;
      this.showTabs = false;
      this.productLabelItemList.sort((a, b) => a.itemId - b.itemId);
      this.setcount();
    }
    this.tabNode = '';
  }

  showAddNewItemInput() {
    this.isAddingNewItem = true;
    // this.setTableHeight();
  }

  quantityTextChange(productItem) {
    if (/^0/.test(productItem.quantity) && productItem.quantity != '0') {
      productItem.quantity = productItem.quantity.replace(/^0/, '');
    }
    this.setcount();
  }

  geuValueChange(value: string, element: any) {
    if (value == 'decrease') {
      const decValue = +element.quantity - 1;
      if (decValue > 0) {
        element.quantity = decValue;
      }
      else {
        element.quantity = 0;
      }
    }
    else {
      element.quantity = +element.quantity + 1;
    }
    this.setcount();
  }


  saveNewItem() {
    if (this.newItemName.trim()) {
      this.selectedItems.push({ itemId: 0, productName: this.newItemName, quantity: 0, selected: false });
      this.dataSource = [...this.selectedItems];
      // Clear the input and hide the new item input
      this.newItemName = '';
      this.isAddingNewItem = false;
    }
  }
  validateEmail(isave = false) {
    this.isNotValid = this.commonService.validateEmail(this.formdata.email, true);
    if (this.isNotValid && isave) {
      this.toastrService.warning('Enter a valid email.');
    }
    this.matcher = new InputErrorStateMatcher(this.isNotValid);
    return this.isNotValid;
  }

  validateForm(): boolean {
    let isValid = true;

    if (!this.formdata.accountNumber) {
      this.toastrService.warning('Account selection is required.');
      isValid = false;
      return isValid;
    }
    if (!this.formdata.email) {
      this.toastrService.warning('Email for ship confirmation is required.');
      isValid = false;
      return isValid;
    }
    if (!this.formdata.address) {
      this.toastrService.warning('Address is required.');
      isValid = false;
      return isValid;
    }
    if (!this.formdata.city) {
      this.toastrService.warning('City is required.');
      isValid = false;
      return isValid;
    }
    if (!this.formdata.state) {
      this.toastrService.warning('State is required.');
      isValid = false;
      return isValid;
    }
    if (!this.formdata.zipCode) {
      this.toastrService.warning('ZIP Code is required.');
      isValid = false;
      return isValid;
    }
    if (!this.formdata.orderedBy) {
      this.toastrService.warning('Ordered By is required.');
      isValid = false;
      return;
    }
    if (!this.formdata.overNightDelivery) {
      this.toastrService.warning('Overnight Delivery selection is required.');
      isValid = false;
      return isValid;
    }
    return isValid;
  }

  saveOrder() {
    this.loaderService.setLoaderStatus(true);
    const selectedItems = this.selectedItems.filter(item => item.quantity > 0);
    if (this.validateForm() && !this.validateEmail(true) && selectedItems.length > 0) {
      const saveObj: any = {};
      saveObj.accountNumber = this.formdata.accountNumber;
      saveObj.accountName = this.formdata.accountName;
      saveObj.address = this.formdata.address;
      saveObj.city = this.formdata.city;
      saveObj.state = this.formdata.state;
      saveObj.zipCode = this.formdata.zipCode;
      saveObj.overNightDelivery = this.formdata.overNightDelivery;
      saveObj.orderedBy = this.formdata.orderedBy;
      saveObj.accountManager = this.formdata.accountManager;
      saveObj.attn = this.formdata.attn;
      saveObj.email = this.formdata.email;
      saveObj.cppproductLabelItems = [];
      selectedItems.forEach(x => {
        saveObj.cppproductLabelItems.push({ itemId: x.itemId, product: x.productName, quantity: x.quantity});
      });
      this.isPlaceOrderDisable = true;
      this.subscription.push(this.cppProductlabel.cppSaveProductLabelOrder(saveObj).subscribe((result: any) => {
        if (result) {
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
          this.toastrService.success('Product Label order saved successfully.');
          this.router.navigate(['/cpp/product-label-landing']);
        } else {
          this.isPlaceOrderDisable = false;
          this.loaderService.setLoaderStatus(false);
          this.toastrService.error('Order not saved in the system.');
        }
      }))
        , (error) => {
          this.isPlaceOrderDisable = false;
          this.loaderService.setLoaderStatus(false);
          this.toastrService.error('Order not saved in the system.');
          LolLoggerService.error(error);
        };
    }
    else {
      this.loaderService.setLoaderStatus(false);
    //  this.toastrService.warning('Enter a valid email.');
    }
  }


}

class InputErrorStateMatcher implements ErrorStateMatcher {
  constructor(private errorstate: boolean) { }
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return this.errorstate;
  }
}
